import React from 'react'
import { observer } from 'mobx-react-lite'

import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'
import { Error as ErrorIcon, CheckCircle as CompleteIcon } from '@mxenabled/mx-icons'

import { useGlobalCopyStore } from '../../../common'
import { useDebtsUiStore } from '../../hooks/useDebtsUiStore'

interface DebtStatusCardProps {
  setTabValue: (val: number) => void
  sx?: any
}

const DebtStatusCard: React.FC<DebtStatusCardProps> = ({ setTabValue, sx }) => {
  const { debts: copy } = useGlobalCopyStore()
  const { showError, showCompleted } = useDebtsUiStore()

  React.useEffect(() => {
    if (showError) {
      setTabValue(1)
    }
  }, [showError])

  if (!showError && !showCompleted) return <></>

  return (
    <Stack gap={16}>
      <Paper sx={{ my: 16, mx: 24, ...sx }}>
        <Alert
          icon={
            showError ? <ErrorIcon filled={true} /> : <CompleteIcon color="success" filled={true} />
          }
          severity="error"
          sx={{
            alignItems: 'start',
            borderLeft: 5,
            borderRadius: 1,
            borderColor: showError ? 'error.main' : 'success.main',
            color: 'text.primary',
            '&.MuiPaper-root': {
              backgroundColor: 'background.paper',
            },
          }}
        >
          <AlertTitle sx={{ fontWeight: 600, marginTop: 2 }} variant="body1">
            {showError ? copy.status_error_title : copy.status_complete_title}
          </AlertTitle>
          <Text component="p" variant="subtitle2">
            {showError ? copy.status_error_description : copy.status_complete_description}
          </Text>
        </Alert>
      </Paper>
      {showError && (
        <Paper sx={{ mb: 16, mt: 100, mx: 24, ...sx }}>
          <Alert
            icon={<></>}
            severity="error"
            sx={{
              borderRadius: 2,
              color: 'text.primary',
              '&.MuiPaper-root': {
                backgroundColor: 'background.paper',
              },
            }}
          >
            <AlertTitle sx={{ fontWeight: 600, marginTop: 2 }} variant="body1">
              {copy.status_info_title}
            </AlertTitle>
            <Text component="p" variant="subtitle2">
              {copy.status_info_description}
            </Text>
          </Alert>
        </Paper>
      )}
    </Stack>
  )
}

export default observer(DebtStatusCard)
